import Request from '../Request.utils'


class HealthAPI {
  health = async () => {
    const res = await Request.call('/api/health', 'GET', undefined, undefined, undefined, );
    return res;
  }
}
export default new HealthAPI()